import { useEffect, useState } from 'react'

export const MaintenanceModal = () => {
  const [open, setOpen] = useState(true)

  useEffect(() => {
    if (!open) return
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = ''
    }
  }, [open])

  if (!open) return null

  return (
    <section className="fixed inset-0 z-[100] flex items-center justify-center bg-black/[0.08] p-4 backdrop-blur-[48px]">
      <div className="relative w-full min-w-0 max-w-[880px]">
        <div className="overflow-hidden rounded-[32px] bg-zWhite100 lg:rounded-[64px]">
          <img
            src="/images/maintenance-modal.webp"
            alt=""
            className="block h-auto w-full"
          />
          <div className="px-6 py-12 text-center lg:px-12 lg:py-16">
            <h2 className="text-3xl font-bold text-zBlack200 lg:text-5xl">
              Pripravujeme niečo lepšie
            </h2>
            <p className="mt-3 text-base text-zGrey400 lg:text-lg">
              Náš tím pracuje na novom webe a platforme.
            </p>
          </div>
        </div>
        <button
          aria-label="close"
          onClick={() => setOpen(false)}
          className="absolute bottom-0 left-0 h-4 w-4 rounded-full bg-[#C0C0C0] opacity-0 transition-opacity duration-200 hover:opacity-40"
        />
      </div>
    </section>
  )
}
